import React, { useEffect, useState, useMemo } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';

export default function ParticlesBackground() {
  const [init, setInit] = useState(false);
  const isMobile = useMemo(() => typeof window !== 'undefined' && window.innerWidth < 768, []);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  if (!init) return null;

  return (
    <Particles
      id="hero-particles"
      className="absolute inset-0 z-0"
      options={{
        fullScreen: false,
        background: { color: { value: 'transparent' } },
        fpsLimit: isMobile ? 30 : 60,
        particles: {
          color: { value: '#F97316' },
          links: {
            color: '#F97316',
            distance: 150,
            enable: true,
            opacity: 0.15,
            width: 1,
          },
          move: {
            enable: true,
            speed: 0.8,
            direction: 'none' as const,
            random: true,
            straight: false,
            outModes: { default: 'out' as const },
          },
          number: {
            density: { enable: true },
            value: isMobile ? 20 : 60,
          },
          opacity: {
            value: { min: 0.1, max: 0.3 },
          },
          size: {
            value: { min: 1, max: 3 },
          },
        },
        interactivity: {
          events: {
            onHover: {
              enable: !isMobile,
              mode: 'grab',
            },
          },
          modes: {
            grab: {
              distance: 140,
              links: { opacity: 0.4 },
            },
          },
        },
        detectRetina: true,
      }}
    />
  );
}
